'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "multiline"];
import { DropdownTextItem } from "../../primitive-dropdown/dropdown-text-item";
import { GenericDropdown } from "./generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function TextsDropdown(_ref) {
  var options = _ref.options,
    multiline = _ref.multiline,
    props = _objectWithoutProperties(_ref, _excluded);
  var textOptions = options.map(function (option) {
    return {
      value: option.value,
      label: option.label,
      description: option.description,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownTextItem, _objectSpread({
          text: option.label,
          description: option.description,
          multiline: multiline
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(GenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    multiline: multiline,
    options: textOptions
  }));
}